import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule, ColumnChooserService, PageService, SortService, FilterService, ResizeService } from '@syncfusion/ej2-angular-grids';
import { ForgotpasswordComponent } from './forgotpassword.component';
import { forgotpasswordHTTPService } from './forgotpassword.service';
import { ForgotpasswordRoutingModule } from './forgotpassword-routing.module';

export const routes = [
  { path: '', component: ForgotpasswordComponent, }
];
@NgModule({
  declarations: [
    ForgotpasswordComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GridModule,
    ForgotpasswordRoutingModule
  ],
  providers: [forgotpasswordHTTPService, ColumnChooserService, PageService, SortService, FilterService, ResizeService],
})
export class ForgotpasswordModule { }
